var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "myCenter",
    attrs: {
      "element-loading-background": "transparent"
    }
  }, [_c('Header'), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _c('div', {
    staticClass: "file"
  }, [_c('ul', _vm._l(_vm.fileList, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.sourceUrl
      }
    }), _c('i', {
      staticClass: "iconfont iconguanbi2",
      on: {
        "click": function click($event) {
          return _vm.removefile(index);
        }
      }
    })]);
  }), 0), !_vm.maxpic ? _c('div', {
    staticClass: "inputfile"
  }, [_c('i', {
    staticClass: "iconfont iconzhaopian"
  }), _c('span', [_vm._v("上传图片")]), _c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "accept": ".png,.jpg"
    },
    on: {
      "change": _vm.uploadpic
    }
  }), _c('i', {
    staticClass: "iconfont"
  })]) : _vm._e()]), _vm._m(1), _c('div', {
    staticClass: "download"
  }, [_vm.excelId !== '' ? _c('p', [_vm._v(" " + _vm._s(_vm.excel) + ".xlsx "), _c('i', {
    staticClass: "iconfont iconguanbi2",
    on: {
      "click": _vm.delexcel
    }
  })]) : _c('div', [_c('span', [_vm._v("上传文件")]), _c('input', {
    attrs: {
      "type": "file",
      "accept": ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      "change": _vm.uploadExcelFile
    }
  })])]), _vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mobile,
      expression: "mobile"
    }],
    staticClass: "mobile",
    domProps: {
      "value": _vm.mobile
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.mobile = $event.target.value;
      }
    }
  }), _vm._m(3), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.remark,
      expression: "remark"
    }],
    staticClass: "remark",
    domProps: {
      "value": _vm.remark
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.remark = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "btn"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("上一步")]), _c('span', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("确认提交")])])]), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('h3', [_vm._v(" 打印内容"), _c('span', [_vm._v("（选填）:")]), _c('em', [_vm._v("请上传清晰的打印内容")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('h3', [_vm._v(" Excel文件"), _c('span', [_vm._v("（选填）:")]), _c('em', [_vm._v("如有批量数据打印需求，请上传文件")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('h3', [_c('b', [_vm._v("*")]), _vm._v("联系方式"), _c('span', [_vm._v("（必填）:")]), _c('em', [_vm._v("请填写正确的手机号，我们会和您取得联系")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('h3', [_vm._v(" 问题描述"), _c('span', [_vm._v("（选填）:")]), _c('em', [_vm._v("如有其他需求，请备注说明")])]);
}];
export { render, staticRenderFns };